import { formatSlotTime } from './lobbyScheduleUtils'
import type { ScheduleConflictDto, ScheduleLegislatorRowDto, ScheduleMeetingDto } from '../../../types/lobbyDay'

export interface ConflictRow {
  key: string
  attendeeName: string
  aLabel: string
  aTime: string
  bLabel: string
  bTime: string
  meetingIdA: string
  meetingIdB: string
}

/** Turn raw double-booking conflicts into human-readable summary rows.
 *  One attendee is double-booked across two overlapping meetings (meetingIdA/B). */
export function describeConflicts(
  conflicts: ScheduleConflictDto[],
  meetings: ScheduleMeetingDto[],
  legislatorById: Map<string, ScheduleLegislatorRowDto>,
  attendeeNameById: Map<string, string>,
): ConflictRow[] {
  const meetingById = new Map(meetings.map((m) => [m.id, m] as const))
  const rows: ConflictRow[] = []
  for (const c of conflicts) {
    const ma = meetingById.get(c.meetingIdA)
    const mb = meetingById.get(c.meetingIdB)
    if (!ma || !mb) continue
    rows.push({
      key: `${c.attendeeId}|${c.meetingIdA}|${c.meetingIdB}`,
      attendeeName: attendeeNameById.get(c.attendeeId) ?? 'Unknown attendee',
      aLabel: legislatorById.get(ma.legislatorId)?.fullName ?? 'Unknown legislator',
      aTime: formatSlotTime(ma.startTime),
      bLabel: legislatorById.get(mb.legislatorId)?.fullName ?? 'Unknown legislator',
      bTime: formatSlotTime(mb.startTime),
      meetingIdA: c.meetingIdA,
      meetingIdB: c.meetingIdB,
    })
  }
  return rows
}
